import React from 'react';
import { Button, useClipboard } from '@chakra-ui/react';
import { Copy } from 'phosphor-react';

// Botão de copiar reutilizável (feedback "Copiado" com destaque verde).
// Compartilhado pelos modais do api-controller (criação e revelação de token).
export function CopyButton({ value, label }: { value: string; label?: string }) {
  const { onCopy, hasCopied } = useClipboard(value);
  return (
    <Button
      size="sm"
      leftIcon={<Copy weight="bold" />}
      onClick={onCopy}
      colorScheme={hasCopied ? 'green' : 'blue'}
    >
      {hasCopied ? 'Copiado' : (label ?? 'Copiar')}
    </Button>
  );
}
